import cardModuleGetters from "./cardModule/getters";

export default {
  ...cardModuleGetters,
};
